// extracted by mini-css-extract-plugin
export default {"button":"FilterDetailedButton_button__Ov3sS","counter":"FilterDetailedButton_counter__zuQlx"};